import { ShopOutlined, UploadOutlined } from "@ant-design/icons";
import { Dropdown, MenuProps } from "antd";
import { FC } from "react";

import FlexContainer from "@/components/FlexContainer";
import { PrimaryText, SecondaryText } from "@/components/Typography/Styled";

import { RouteItem, StyledMoreOutlined, StyledRouteDropdown } from "./Styled";

export interface RouteCardProps {
    id: string;
    name: string;
    marketCount?: number;
    agentFullName: string;
    onClick?: () => void;
    onExportSingleRoute?: () => void;
    onViewMarkets?: () => void;
    onDeleteRoute?: () => void;
    disableExport: boolean;
}

const RouteCard: FC<RouteCardProps> = ({
    id,
    name,
    marketCount,
    agentFullName,
    onClick,
    onExportSingleRoute,
    onViewMarkets,
    onDeleteRoute,
    disableExport,
}) => {
    const dropdownItems: MenuProps["items"] = [
        !disableExport && {
            key: "export",
            icon: <UploadOutlined style={{ fontSize: 20 }} />,
            label: <PrimaryText fontSize={16}>Експорт в Excel</PrimaryText>,
        },
        {
            key: "viewAll",
            icon: <ShopOutlined style={{ fontSize: 20 }} />,
            label: <PrimaryText fontSize={16}>Переглянути всі ТТ</PrimaryText>,
        },
        // {
        //     key: "delete",
        //     icon: <DeleteOutlined style={{ fontSize: 20, color: "#BF2E2D" }} />,
        //     label: (
        //         <PrimaryText fontSize={16} style={{ color: "#BF2E2D" }}>
        //             Видалити
        //         </PrimaryText>
        //     ),
        // },
    ].filter(Boolean);

    const handleMenuClick: MenuProps["onClick"] = ({ key, domEvent }) => {
        domEvent.stopPropagation();
        if (key === "export") onExportSingleRoute?.();
        if (key === "viewAll") onViewMarkets?.();
        if (key === "delete") onDeleteRoute?.();
    };

    return (
        <RouteItem key={id} onClick={onClick}>
            <FlexContainer justifyContent="space-between" width="100%">
                <PrimaryText fontSize={16}>{name}</PrimaryText>
                <Dropdown
                    trigger={["click"]}
                    menu={{
                        items: dropdownItems,
                        onClick: handleMenuClick,
                    }}
                    dropdownRender={(menu) => (
                        <StyledRouteDropdown>{menu}</StyledRouteDropdown>
                    )}
                >
                    <span onClick={(e) => e.stopPropagation()}>
                        <StyledMoreOutlined />
                    </span>
                </Dropdown>
            </FlexContainer>

            <FlexContainer gap="8px">
                <SecondaryText>Кількість ТТ:</SecondaryText>
                <SecondaryText>{marketCount ?? "-"}</SecondaryText>
            </FlexContainer>

            <FlexContainer gap="8px">
                <SecondaryText>ТА:</SecondaryText>
                <SecondaryText>{agentFullName}</SecondaryText>
            </FlexContainer>
        </RouteItem>
    );
};

export default RouteCard;
